module.exports = __webpack_public_path__ + "img/server.5b86ffca.svg";